export default __webpack_public_path__ + "static/media/BuyIcon.e8cbc133.svg";